<template>
<div class="chapter">
<div class="inner_page">
<h1 class="prect" id="contents"><a id="pvi"></a><a id="pvii"></a>Contents</h1>
<p class="contents-prect"><a href="#/foreword.htm#fore">Foreword</a></p>
<p class="contents-pt"><a href="#/part1.htm#part1"><b>Part One</b></a></p>
<p class="contents-ct"><a href="#/chap01.htm#chap1">A Girl from a Good Family</a></p>
<p class="contents-ct"><a href="#/chap02.htm#chap2">Youth</a></p>
<p class="contents-ct"><a href="#/chap03.htm#chap3">You Are Svengali—I Am Trilby</a></p>
<p class="contents-ct"><a href="#/chap04.htm#chap4">Hollywood</a></p>
<p class="contents-ct"><a href="#/chap05.htm#chap5">Giants</a></p>
<p class="contents-ct"><a href="#/chap06.htm#chap6">Writers</a></p>
<p class="contents-ct"><a href="#/chap07.htm#chap7">Painters and Sculptors</a></p>
<p class="contents-ct"><a href="#/chap08.htm#chap8">Composers</a></p>
<p class="contents-ct"><a href="#/chap09.htm#chap9">Artists</a></p>
<p class="contents-ct"><a href="#/chap10.htm#chap10">After <i>The Devil Is a Woman</i></a></p>
<p class="contents-pt"><a href="#/part2.htm#part2"><b>Part Two</b></a></p>
<p class="contents-ct"><a href="#/chap11.htm#chap11">The War</a></p>
<p class="contents-ct"><a href="#/chap12.htm#chap12">A New Adventure</a></p>
<p class="contents-ct"><a href="#/epilogue.htm#epil">Epilogue</a></p>
<p class="contents-prect-"><a href="#/selected_chronology.htm#chrono">Selected Chronology</a></p>
<p class="contents-prect"><a href="#/index.htm#index">Index</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?380db8fa